import axios from 'axios';
import { net_api_url } from 'components/Store';
const highlightWidget = async (objectType, objectId, keywordListId, includeBrandingProperty) => {
  const source = new AbortController();
  try {
    let contentRequest = {
      signal: source?.signal,
    };
    let highlightedResults = await axios.post(
      `${net_api_url}/api/widget/highlight-content${!includeBrandingProperty ? '?removeRelativeLinks=true' : ''}`,
      {
        objectType: objectType,
        objectId: objectId,
        keywordListId: keywordListId,
      },
      contentRequest
    );
    return highlightedResults ? highlightedResults.data : null;
  } catch (error) {}
};

export default highlightWidget;
